import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getBumperDetails, getBumpers } from "./action";

export const bumperEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = bumperEntityAdapter.getInitialState({
  count: 0,
});

export const bumpersSlice = createSlice({
  name: "bumpers",
  initialState: initialState,
  reducers: {
    showUploadBumperModal: (state, action) => {
      state.modals.selectUploadBumperModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBumpers.fulfilled, (state, action) => {
      if (action.payload.success) {
        bumperEntityAdapter.setAll(state, action.payload.data);
        state.count = action.payload.totalLength;
      }
    });
    builder.addCase(getBumperDetails.fulfilled, (state, action) => {
      if (action.payload.success) {
        const bumper = action.payload.data;

        state.entities = {
          ...state.entities,
          [bumper._id]: bumper,
        };
      }
    });
  },
});

export const { showUploadBumperModal } = bumpersSlice.actions;

export default bumpersSlice.reducer;
